import React from "react";
import {MappedComponentProperties} from "@adobe/aem-react-editable-components";
import {GlobalPrivacyControlPopupModel} from "../../ExportedTypes/ExportedTypes";
import extractModelId from "../../utils/extract-model-id";
import { GlobalPrivacyControlPopup } from "../../ui.lib/components/shared/global-privacy-control-popup/global-privacy-control-popup";
import ErrorBoundary from "../../utils/ErrorBoundary";

const GlobalPrivacyControlPopupComponent = (props: MappedComponentProperties & GlobalPrivacyControlPopupModel) => {
    const {
        gpcPopupCopy
    } = props;

    return (
        <ErrorBoundary>
            <div id={extractModelId(props.cqPath)} >
                <GlobalPrivacyControlPopup gpcPopupCopy={gpcPopupCopy}></GlobalPrivacyControlPopup>
            </div>
        </ErrorBoundary>
        
    );
};


export default GlobalPrivacyControlPopupComponent;
